export default "/images/ab8d29c1431229474b03de71e135bcda.avif";